import template from './floatingHelper.html';
import controller from './floatingHelperCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
